export const routes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "index" */ './Index.vue')
  },
  {
    path: '/auth/recover-password/:token',
    component: () =>
      import(/* webpackChunkName: "auth" */ './recuperar-senha.vue'),
    props: true,
    name: 'auth.token'
  }
]
